import { EntityState, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbstractUiEntityStore } from 'projects/app-misc/src/app/modules/data/abstract-ui-entity.store';
import { OverallReport } from 'projects/app-misc/src/app/modules/reports/data/overall-report-page';

export interface SystemReportsState extends EntityState<OverallReport, number> {
  ui: {
    searchQuery: string
  };
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({name: 'systemReport'})
export class SystemReportsStore extends AbstractUiEntityStore<SystemReportsState> {
  constructor() {
    super({
      ui: {
        searchQuery: ''
      }
    })
  }

  updateSearchQuery(searchQuery: string) {
    this.updateUi({
      searchQuery
    })
  }
}
